<script>
import { Helper, debounce } from '@/mixin/helper'
import moment from 'moment'
import * as deviceLogApi from '@/services/rest-api-sms/lib/device-log/device-log'

export default {
  mixins: [Helper],
  props: {
    title: {
      type: String,
      default: 'Status Online Command',
    },
    modal: {
      type: Boolean,
      default: false,
    },
    vehicleId: {
      type: Number,
      default: null,
    },
    region: {
      type: String,
      default: 'SG',
    },
  },
  data() {
    return {
      filter: null,
      period: null,
      dateRange: [],
      maxDate: 1,
      pastDate: null,
      futureEnd: moment().add(24, 'hours'),
      activeTab: 0, // 0 = old Log, 1 = new log
      startDate: null,
      endDate: null,

      totalPages: 0,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 25, 50, 100],
      filteredItems: [],
      deviceLogs: [],

      totalPagesOld: 0,
      currentPageOld: 1,
      perPageOld: 10,
      totalRowsOld: 0,
      pageOptionsOld: [10, 25, 50, 100],
      filteredItemsOld: [],
      deviceLogsOld: [],

      filterType: {
        all: true,
        responseDevice: false,
        sendUser: false,
        command: false,
        queue: false,
        failedSent: false,
        executeConfirmed: false,
      },
      type: null,

      loading: false,

      fields: [
        {
          key: 'message_on',
          label: 'Tanggal Pesan',
          thClass: 'text-center mc-table--170',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'message',
          label: 'Pesan',
        },
        {
          key: 'user_name',
          label: 'Dari',
        },
        {
          key: 'type',
          label: 'Jenis',
        },
      ],

      filters: [
        { key: 'all', code: null, label: 'deviceLog.filterType.all' },
        { key: 'responseDevice', code: 'R', label: 'deviceLog.filterType.responseDevice' },
        { key: 'sendUser', code: 'S', label: 'deviceLog.filterType.sendUser' },
        { key: 'command', code: 'C', label: 'deviceLog.filterType.command' },
        { key: 'queue', code: 'Q', label: 'deviceLog.filterType.queue' },
        { key: 'failedSent', code: 'X', label: 'deviceLog.filterType.failedSent' },
        { key: 'executeConfirmed', code: 'E', label: 'deviceLog.filterType.executeConfirmed' },
      ],
    }
  },

  validations: {},

  computed: {
    showModal: {
      get() {
        return this.modal
      },
      set(newVal) {
        this.$emit('update:modal', newVal)
      },
    },
    shortcuts() {
      let startDay = new Date()
      startDay.setHours(0, 0, 0)
      let endDay = new Date()
      endDay.setHours(23, 59, 59)
      const createLastRange = (value, unit) => {
        return () => {
          const endDate = new Date()
          const startDate = moment(endDate).subtract(value, unit).toDate()

          return [startDate, endDate]
        }
      }

      return [
        { text: 'Hari Ini', onClick: () => [startDay, endDay] },
        { text: '1 minute', onClick: createLastRange(1, 'minutes') },
        { text: '5 minute', onClick: createLastRange(5, 'minutes') },
        { text: '10 minute', onClick: createLastRange(10, 'minutes') },
        { text: '15 minute', onClick: createLastRange(15, 'minutes') },
        { text: '20 minute', onClick: createLastRange(20, 'minutes') },
        { text: '30 minute', onClick: createLastRange(30, 'minutes') },
        { text: '1 hour', onClick: createLastRange(1, 'hours') },
      ]
    },
  },

  async created() {
    await this.fetchLogs()
  },

  methods: {
    async fetchLogs() {
      this.loading = true
      const formatDate = (date) => {
        return moment(date, [
          'YYYY-MM-DD HH:mm:ss',
          'YYYY-MM-DDTHH:mm:ss',
          'YYYY-MM-DD'
        ]).format('YYYY-MM-DD HH:mm:ss') + '+07'
      }

      let params = {
        page: this.currentPage,
        limit: this.perPage,
        search: this.filter,
        filters: [
          `vehicle_id eq ${this.vehicleId}`,
        ],
      }

      if (this.type && this.type.length > 0) {
        if (this.type.length === 1) {
          // single
          params.filters.push(`type eq '${this.type[0]}'`)
        } else {
          // multi
          const values = this.type.map((v) => `'${v}'`).join(', ')
          params.filters.push(`type in (${values})`)
        }
      }

      if (this.startDate) {
        let startDate = formatDate(this.startDate)
        params.filters.push(`message_on gte '${startDate}'`)
      }

      if (this.startDate) {
        let endDate = formatDate(this.endDate)
        params.filters.push(`message_on lte '${endDate}'`)
      }

      try {
        const response = await deviceLogApi.get(params, this.region)

        if (!response?.data) return

        this.deviceLogs = response.data.paginated_result
        this.filteredItems = response.data.paginated_result
        this.totalRows = response.metadata.total_count
        this.totalPages = response.metadata.total_page
        this.currentPage = response.metadata.page

        this.loading = false
      } catch (error) {
        this.$toast.error('Error loading logs')
      } finally {
        this.loading = false
      }
    },

    changePage(e) {
      this.currentPage = e
      this.fetchLogs()
    },

    resetFilter(newPerPage) {
      this.perPage = newPerPage
      this.currentPage = 1
      this.fetchLogs()
    },

    changePageOld(e) {
      this.currentPageOld = e
      this.fetchOldLogs()
    },

    resetFilterOld(newPerPage) {
      this.perPageOld = newPerPage
      this.currentPageOld = 1
    },

    pickDate(date) {
      let dateRange = this.dateRange

      if (!dateRange[0] && !dateRange[1]) {
        dateRange[0] = Helper.methods.momentYmDHms(date)
      } else if (!dateRange[1]) {
        dateRange[1] = Helper.methods.momentYmDHms(date)
      }

      this.pastDate = new Date(date.getTime() - 24 * this.maxDate * 3600 * 1000)
      this.futureEnd = moment().add(24, 'hours')
    },

    disabledDate: function (date) {
      let today = new Date()
      today.setHours(0, 0, 0, 0)
      return date > today
    },

    disabledTime: function (time) {
      if (this.dateRange.length === 0) return false
      let startRange = new Date(this.dateRange[0])
      const nextTimeDisabled = new Date(startRange.getTime() + 24 * 3600 * 1000)
      return time > nextTimeDisabled
    },

    async handleOpenDatePicker(date) {
      this.currentPage = 1
      if (date[0] === null && date[1] === null) {
        this.pastDate = null
        this.futureEnd = moment().add(24, 'hours')
      }
      this.startDate = date[0] ? Helper.methods.momentYmDHms(date[0]) : null
      this.endDate = date[1] ? Helper.methods.momentYmDHms(date[1].setHours(23, 59, 59)) : null

      await this.fetchLogs()
    },

    searchData: debounce(function () {
      this.fetchLogs()
    }, 600),

    async updateFilter(param) {
      const map = {
        responseDevice: 'R',
        sendUser: 'S',
        command: 'C',
        queue: 'Q',
        failedSent: 'X',
        executeConfirmed: 'E',
      }

      // Kalau klik ALL → reset semua
      if (param === 'all') {
        Object.keys(this.filterType).forEach((k) => {
          this.filterType[k] = false
        })
        this.filterType.all = true
        this.type = null
        return await this.fetchLogs()
      }

      // Toggle ON/OFF filter lain
      this.filterType[param] = !this.filterType[param]

      // Hitung jumlah filter aktif (selain ALL)
      const activeCount = Object.keys(this.filterType).filter(
        (k) => k !== 'all' && this.filterType[k]
      ).length

      // Jika lebih dari 5 → reset ALL
      if (activeCount > 5) {
        Object.keys(this.filterType).forEach((k) => {
          this.filterType[k] = false
        })
        this.filterType.all = true
        this.type = null
        return await this.fetchLogs()
      }

      // Matikan ALL jika filter lain aktif
      this.filterType.all = activeCount === 0

      // Kirim type ke backend sebagai array filter code
      this.type = Object.keys(this.filterType)
        .filter((k) => k !== 'all' && this.filterType[k])
        .map((k) => map[k])

      await this.fetchLogs()
    },
  },
}
</script>
<template>
  <div>
    <b-modal
      v-model="showModal"
      class="mc-modal"
      id="modal-form"
      :title="title"
      size="xl"
      centered
      :hide-header-close="loading"
      no-close-on-backdrop
    >
      <div class="card-body mc-modal__filter p-2">
        <div class="clearfix">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <date-picker
                v-model="period"
                type="date"
                :placeholder="'Pilih Tanggal'"
                range
                :shortcuts="shortcuts"
                id="mc-datepicker-device-log"
                @pick="pickDate"
                :disabled-date="disabledDate"
                @change="handleOpenDatePicker"
              />
            </div>
            <div class="col-sm-12 col-md-6">
              <!-- Search -->
              <div class="float-end">
                <div class="mc-table-view">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                    <div class="row">
                      <label class="d-inline-flex align-items-center mc-table-view__search ms-2">
                        <i class="mc-fa fas fa-search" />
                        <b-form-input
                          v-model="filter"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="form-control"
                          @input="searchData"
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>
          </div>
        </div>
        <!-- Filter By Request Validate -->
        <b-button
          v-for="f in filters"
          :key="f.key"
          :variant="filterType[f.key] ? 'secondary' : 'light'"
          size="sm"
          class="me-2"
          :class="filterType[f.key] ? 'device-log-type-tab' : ''"
          @click="updateFilter(f.key)"
        >
          {{ $t(f.label) }}
        </b-button>
        <div class="card-body mt-2">
          <b-tabs v-model="activeTab" content-class="p-1 text-muted">
            <b-tab class="border-0">
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-home"></i>
                </span>
                <span class="d-none d-sm-inline-block">Device Logs</span>
              </template>
              <div class="table-responsive mb-0 my-3 border border-1">
                <b-table
                  class="datatables"
                  :items="deviceLogs"
                  :fields="fields"
                  :busy="loading"
                  show-empty
                  responsive="sm"
                  hover
                  :empty-text="$t('global.emptyTable')"
                  :empty-filtered-text="$t('global.emptyFilteredTable')"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </template>
                  <!-- Header untuk kolom 'type' -->
                  <template #head(type)>
                    <b-tooltip target="jenis-tooltip" triggers="hover" placement="top">
                      <p class="text-start">R = Response Device</p>
                      <p class="text-start">S = Send User</p>
                      <p class="text-start">C = Command</p>
                      <p class="text-start">Q = Queue</p>
                      <p class="text-start">X = Failed Sent</p>
                      <p class="text-start">E = Execute Confirmed</p>
                    </b-tooltip>
                    <span id="jenis-tooltip" style="cursor: help">
                      Jenis <i class="fas fa-info-circle text-muted ms-1"></i>
                    </span>
                  </template>
                  <template #cell(message_on)="data" class="text-center">
                    <p>
                      {{ data.item.message_on ? momentDateShortMonth(data.item.message_on) : '-' }}
                      <span class="text-muted my-0">
                        {{ data.item.message_on ? momentTimeSeconds(data.item.message_on) : '' }}
                      </span>
                    </p>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      {{ $t('show') }}
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        @change="resetFilter"
                      />
                      {{ $t('entry') }}. {{ $t('show') }}&nbsp;<strong>{{
                        filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0
                      }}</strong>
                      &nbsp;{{ $t('to') }}&nbsp;<strong>{{
                        currentPage != totalPages
                          ? currentPage * perPage
                          : (currentPage - 1) * perPage + filteredItems.length
                      }}</strong>
                      &nbsp;{{ $t('from') }}&nbsp;<strong>{{ totalRows }}</strong
                      >&nbsp;{{ $t('entry') }}.
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        @change="changePage"
                      />
                    </ul>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col cols="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" :disabled="loading" class="me-3">
              Kembali
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
